import { createContext, useContext, useRef, useMemo } from "react";
import PropTypes from "prop-types";

const AddressModalCallbackContext = createContext(null);

export const AddressModalCallbackProvider = ({ children }) => {
  // AddEditAddressModal callbacks
  const onSubmitRef = useRef(null);

  // InvalidAddressModal callbacks
  const invalidOnSubmitRef = useRef(null);
  const invalidOnEditRef = useRef(null);

  // VerifyAddressModal callbacks
  const verifyOnSubmitRef = useRef(null);
  const verifyOnEditRef = useRef(null);

  const value = useMemo(
    () => ({
      // AddEditAddressModal
      setOnSubmit: (handler) => {
        onSubmitRef.current = handler;
      },
      getOnSubmit: () => onSubmitRef.current,

      // InvalidAddressModal
      setInvalidOnSubmit: (handler) => {
        invalidOnSubmitRef.current = handler;
      },
      getInvalidOnSubmit: () => invalidOnSubmitRef.current,
      setInvalidOnEdit: (handler) => {
        invalidOnEditRef.current = handler;
      },
      getInvalidOnEdit: () => invalidOnEditRef.current,

      // VerifyAddressModal
      setVerifyOnSubmit: (handler) => {
        verifyOnSubmitRef.current = handler;
      },
      getVerifyOnSubmit: () => verifyOnSubmitRef.current,
      setVerifyOnEdit: (handler) => {
        verifyOnEditRef.current = handler;
      },
      getVerifyOnEdit: () => verifyOnEditRef.current,
    }),
    [],
  );

  return <AddressModalCallbackContext.Provider value={value}>{children}</AddressModalCallbackContext.Provider>;
};

AddressModalCallbackProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export const useAddressModalCallback = () => {
  const context = useContext(AddressModalCallbackContext);
  if (!context) {
    throw new Error("useAddressModalCallback must be used within AddressModalCallbackProvider");
  }
  return context;
};

export default AddressModalCallbackContext;
